(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailAddressEmailsListCtrl', EmailAddressEmailsListCtrl);

    /**
     * @ngdoc controller
     * @name EmailAddressEmailsListCtrl
     *
     * @description
     * Dialog which lists the emails having email address audits.
     * Email address audits are typically created for notifications, e.g. bounce, complaints.
     */

    EmailAddressEmailsListCtrl.$inject = [
        '$q',
        '$routeParams',
        'SystemService',
        'EmailService',
        'EmailAddressService',
        'DialogService',
        'NavigationAidService',
        'ChilliUserProfileService',
        'WindowTitleService'];

    function EmailAddressEmailsListCtrl(
        $q,
        $routeParams,
        SystemService,
        EmailService,
        EmailAddressService,
        DialogService,
        NavigationAidService,
        ChilliUserProfileService,
        WindowTitleService) {

        var vm = this;
        var emailAddressId = null;
        vm.emailAddressEmailsCount = 0;
        vm.currentPage = 1;
        vm.loadingGrid = false;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.notFound = false;
        vm.error = null;
        vm.close = close;
        vm.updateList = updateList;
        Object.defineProperty(vm, 'titleText', { get: function () { if (_.isNil(vm.emailAddress)) { return 'Emails to '; } else { return 'Emails to ' + vm.emailAddress.Address; } } });

        activate();

        function activate() {
            WindowTitleService.setTitle(vm.titleText);

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;
                    WindowTitleService.setTitle(vm.titleText);
                }
            });
        }

        /**
         * Initialises the emails list.
         * A watch is set on the currentPage variable, when this is changed the list will be updated.
         */
        function loadEverything() {
            emailAddressId = $routeParams.id;

            var loadPromises = [];

            var getPageSizePromise = SystemService.getMenuListSize('Email Address Emails')
                .then(getListPageSizeOk);

            var getEmailAddress = EmailAddressService.get(emailAddressId)
                .then(getEmailAddressOk, getEmailAddressError);

            loadPromises.push(getPageSizePromise);
            loadPromises.push(getEmailAddress);

            return $q.all(loadPromises)
                .then(function () {
                    updateList();
                }, function (response) {
                    vm.error = response;
                    vm.loadingGrid = false;
                });


            function getListPageSizeOk(data) {
                vm.listPageSize = data;
            }

            function getEmailAddressOk(data) {
                vm.emailAddress = data;
            }

            function getEmailAddressError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                }

                return $q.reject(response);
            }
        }

        /**
         * Refreshes the emails list.
         */
        function updateList() {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            vm.loadingGrid = true;

            var getPromise = EmailService.query({
                emailAddressId: emailAddressId,
                currentPage: vm.currentPage,
                pageSize: vm.listPageSize
            })
                .then(getEmailAddressEmailsOk, getEmailAddressEmailsError)
                .then(function () {
                    vm.loadingGrid = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getEmailAddressEmailsOk(data) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = null;
                    vm.emailAddressEmails = data.Emails;
                    vm.emailAddressEmailsCount = data.EmailsCount;
                }
                else {
                    return $q.reject();
                }
            }

            function getEmailAddressEmailsError(response) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        /**
         * 'Close' the current view by navigating back to the previous page
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();